import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import LeadsDataPage from '@/components/analytics/pages/LeadsDataPage';
import AnalyticsPage from '@/components/analytics/pages/AnalyticsPage';

function LeadsDashboard() {
  const [activeTab, setActiveTab] = useState("leads-data");

  return (
    <div className="container mx-auto p-4 max-w-7xl">
      <h1 className="text-3xl font-bold mb-6">Lead Management System</h1>
      
      <Tabs defaultValue="leads-data" value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full max-w-md grid-cols-2">
          <TabsTrigger value="leads-data">Leads Data</TabsTrigger>
          <TabsTrigger value="analytics">Analytics</TabsTrigger>
        </TabsList>
        
        <TabsContent value="leads-data">
          <LeadsDataPage />
        </TabsContent>
        
        <TabsContent value="analytics">
          <AnalyticsPage />
        </TabsContent>
      </Tabs>
    </div>
  );
}

export default LeadsDashboard;